/**
 * Malaysian banks an affiliate can be paid into.
 *
 * A plain list rather than a lookup table: the payout is made by a human doing a
 * transfer, so the name only has to be unambiguous to them. Kept here (not in a
 * component) so the seller-side payout screen shows exactly the same names.
 */
export const MY_BANKS: readonly string[] = [
  "Affin Bank",
  "Agrobank",
  "Alliance Bank",
  "AmBank",
  "Bank Islam",
  "Bank Muamalat",
  "Bank Rakyat",
  "Bank Simpanan Nasional",
  "CIMB Bank",
  "Citibank",
  "Hong Leong Bank",
  "HSBC Bank",
  "Kuwait Finance House",
  "Maybank",
  "MBSB Bank",
  "OCBC Bank",
  "Public Bank",
  "RHB Bank",
  "Standard Chartered",
  "UOB Bank",
  "Boost Bank",
  "GXBank",
  "AEON Bank",
] as const;
